import React, { useEffect, useState } from "react";
import CareersLayout from "./layouts/CareersLayout";
import useFilters from "helpers/hooks/useFilters";
import { useLocalizedTranslation } from "helpers/hooks/useLocalizedTranslation";
import useListingHeader from "helpers/hooks/useListingHeader";
import useCareers from "store/careers/service-hook";
import CareersListing from "./listing/CareersSkillsListing";
import useRedirect from "helpers/hooks/useRedirect";
import { payloadBool } from "helpers/utils/utilities";

const CareerExplore = () => {
  const { search, setSearch, setSort, sort } = useListingHeader(1, "relevance");
  const { navigateCECareers, navigateCESkills } = useRedirect();
  const { t } = useLocalizedTranslation();
  const { fetchRecommendations } = useCareers();
  const { selected } = useFilters();
  const [loading, setLoading] = useState(false);
  const [recommendations, setRecommendations] = useState({
    careers: [],
    skills: [],
  });

  useEffect(() => {
    fetchData();
  }, [sort, selected.career_status]);

  const fetchData = async () => {
    setLoading(true);
    const filters = { sort_by: sort };
    if (selected.career_status)
      filters["saved"] = payloadBool(selected?.career_status === "saved");
    const res = await fetchRecommendations(filters);
    const { careers = [], skills = [] } = res || {};
    setRecommendations({ careers, skills });
    setLoading(false);
  };

  return (
    <CareersLayout
      search={search}
      setSearch={setSearch}
      gridType={1}
      setSort={setSort}
      sort={sort}
      loading={loading}
    >
      <h3 className="mt-5 ml-2">{t("Recommended Careers")}</h3>
      <CareersListing
        list={recommendations?.careers}
        t={t}
        gridType={1}
        fromRecommendations
        loading={loading}
        showAll={navigateCECareers}
        setList={(list) =>
          setRecommendations((prev) => ({
            ...prev,
            careers: list,
          }))
        }
      />
      <h3 className="mt-2 ml-2">{t("Recommended Skills")}</h3>
      <CareersListing
        list={recommendations?.skills}
        t={t}
        gridType={1}
        loading={loading}
        fromRecommendations
        showAll={navigateCESkills}
        isSkills
        setList={(list) =>
          setRecommendations((prev) => ({
            ...prev,
            skills: list,
          }))
        }
      />
    </CareersLayout>
  );
};

export default CareerExplore;
